// extracted by mini-css-extract-plugin
export default {"contenttab":"Contenttab_contenttab__TAV+B"};